<lazy-echart
    (mousedown)="$event.stopPropagation()"
    (mousemove)="$event.stopPropagation()"
    (mouseup)="$event.stopPropagation()"
    class="chart"
    [class.chart--fixed-height]="hasFixedHeight"
    [options]="chartOptions">
</lazy-echart>
